import { Injectable, OnDestroy } from '@angular/core';
import { NotificationService } from '@mydocma/component-library/src/lib/notification';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { Logger } from '@mydocma/common/src/lib/logger';
import { MmStructureSyncService, StructureSyncError, StructureSyncErrorKind } from './mm-structure-sync.service';

@Injectable()
export class MmStructureSyncViewService implements OnDestroy {

  private readonly subscription = new Subscription();

  constructor(
    private readonly syncService: MmStructureSyncService,
    private readonly notificationService: NotificationService,
    private readonly translateService: TranslateService,
    private readonly logger: Logger,
  ) {
    this.subscription.add(
      this.syncService.errors$.subscribe(error => this.handleError(error))
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private handleError(error: StructureSyncError): void {
    this.logger.error(`${error.kind} ${error.reason ?? ''} ${JSON.stringify(error.info)}`, '', 'MmStructureSyncViewService');
    if (error.kind === StructureSyncErrorKind.ResolutionFailed) {
      return;
    }
    this.notificationService.error(this.buildMessage(error));
  }

  private buildMessage(error: StructureSyncError): string {
    if (error.kind === StructureSyncErrorKind.BackendFailed && error.reason) {
      return this.translateService.instant('MM.structure.sync.failedWithReason', { reason: error.reason });
    }
    if (error.kind === StructureSyncErrorKind.BackendFailed) {
      return this.translateService.instant('MM.structure.sync.failedGeneric');
    }
    return this.translateService.instant('MM.structure.sync.resolutionFailed');
  }
}
